<template>
  <div class="flex flex-col items-start sm:flex-row sm:items-center gap-12 mt-8 mb-24">
    <TrustedSitterBannerIcon :width="148" :height="30" aria-hidden="true" />
    <Pill :color="PillColor.yellow">PLEASE CONFIRM</Pill>
  </div>
  <p class="text-body text-grey-body mb-16">
    Trusted Sitters earn a profile badge, which helps you stand out and builds credibility that can unlock more opportunities.
  </p>

  <p v-if="errorMessage" class="text-body text-critical mb-16" role="alert">{{ errorMessage }}</p>

  <div class="flex flex-col items-center pt-8">
    <div class="flex flex-col sm:flex-row justify-center gap-8 w-full">
      <Button
        value="Yes, decline invitation"
        variant="outlined"
        size="medium"
        class="w-full sm:w-auto"
        :loading="submitting === 'DECLINE'"
        :disabled="Boolean(submitting)"
        @click="emit('confirmDecline')"
      />
      <Button
        value="Keep my invitation & accept"
        variant="primary"
        size="medium"
        class="w-full sm:w-auto"
        :loading="submitting === 'ACCEPT'"
        :disabled="Boolean(submitting)"
        @click="emit('accept')"
      />
    </div>
    <button
      type="button"
      class="text-body text-grey-body mt-16 primary-focus"
      :disabled="Boolean(submitting)"
      @click="emit('remindLater')"
    >
      Remind me later
    </button>
  </div>

  <TrustedCaregiverCcmAcknowledgment />
</template>

<script setup lang="ts">
import Button from '@/components/button/Button.vue';
import Pill from '@/components/pill/Pill.vue';
import { PillColor } from '@/components/pill/Pill.vue';
import TrustedSitterBannerIcon from '@/graphics/icons/TrustedSitterBannerIcon.vue';
import type { TrustedCaregiverInviteResponse } from '@/graphql/provider/trusted_caregiver/mutations';
import TrustedCaregiverCcmAcknowledgment from './TrustedCaregiverCcmAcknowledgment.vue';

defineOptions({ name: 'TrustedCaregiverDeclineConfirmContent' });

defineProps<{
  submitting: TrustedCaregiverInviteResponse | null;
  errorMessage: string;
}>();

const emit = defineEmits<{
  confirmDecline: [];
  accept: [];
  remindLater: [];
}>();
</script>
